import React from 'react';
import ReactDOM from 'react-dom';

import LicenseNavigatorV2 from '~/components/legacy/LicenseNavigatorV2.jsx';

let elements = document.querySelectorAll('[data-react-component=LicenseNavigatorV2Demo]');

elements.forEach(function(element) {
  let reactProps = JSON.parse(element.dataset.reactProps);

  ReactDOM.render(
    <React.StrictMode>
      <LicenseNavigatorV2 {...reactProps} />
    </React.StrictMode>,
    element
  );
});

export default LicenseNavigatorV2;
